import { CONFIG } from './constant';

export const present = (state, interactors) => {
  const journey = interactors.journey;
  const session = interactors.session;
  const siteBranding = interactors.siteBranding;

  let config;

  if (journey.selectors.journeyFetched(state.journey)) {
    const configKey = journey.selectors.footerConfig(state.journey);
    const data = {
      privacyPolicies: session.selectors.privacyPolicies(state.session),
      disclaimer: siteBranding.selectors.disclaimer(state.siteBranding),
    };
    const configs = CONFIG(data);
    config = configs[configKey] || configs.STANDARD;
  }

  return {
    ...state.footer,
    config,
  };
};
